/* Collection filters, PDP set selector and tabs, ported from the demo site. */
(() => {
  document.addEventListener('DOMContentLoaded', () => {
    // Collection search / filter / sort
    const grid = document.querySelector('[data-product-grid]');
    if (grid) {
      const cards = [...grid.querySelectorAll('[data-product-card]')];
      const q = document.querySelector('[data-store-q]');
      const phase = document.querySelector('[data-store-phase]');
      const sort = document.querySelector('[data-store-sort]');
      const count = document.querySelector('[data-store-count]');
      const empty = document.querySelector('[data-store-empty]');

      let concernVal = 'all';
      document.querySelectorAll('.concern-chip[data-concern]').forEach((chip) => {
        chip.addEventListener('click', () => {
          document.querySelectorAll('.concern-chip[data-concern]').forEach((c) => c.classList.remove('is-active'));
          chip.classList.add('is-active');
          concernVal = chip.dataset.concern || 'all';
          apply();
        });
      });

      const apply = () => {
        const query = (q?.value || '').trim().toLowerCase();
        const phaseVal = phase?.value || 'all';
        const sortVal = sort?.value || 'featured';
        let visible = cards.filter((card) => {
          const hay = (card.dataset.search || '').toLowerCase();
          const p = (card.dataset.phase || '').toLowerCase();
          const c = (card.dataset.concern || '').toLowerCase();
          if (query && !hay.includes(query)) return false;
          if (phaseVal !== 'all' && p !== phaseVal) return false;
          if (concernVal !== 'all' && !c.split(/\s+/).includes(concernVal)) return false;
          return true;
        });
        if (sortVal === 'price-asc' || sortVal === 'price-desc') {
          visible.sort((a, b) => {
            const pa = Number(a.dataset.price || 0);
            const pb = Number(b.dataset.price || 0);
            return sortVal === 'price-asc' ? pa - pb : pb - pa;
          });
        } else if (sortVal === 'name') {
          visible.sort((a, b) => (a.dataset.name || '').localeCompare(b.dataset.name || ''));
        }
        cards.forEach((c) => { c.hidden = true; });
        visible.forEach((c) => {
          c.hidden = false;
          grid.appendChild(c);
        });
        if (count) count.textContent = `${visible.length} product${visible.length === 1 ? '' : 's'}`;
        if (empty) empty.hidden = visible.length > 0;
      };

      q?.addEventListener('input', apply);
      phase?.addEventListener('change', apply);
      sort?.addEventListener('change', apply);
      if (q || phase || sort) apply();
    }

    // Keyboard: / focuses search when present
    document.addEventListener('keydown', (e) => {
      if (e.key === '/' && !/input|textarea|select/i.test(document.activeElement?.tagName || '')) {
        const s = document.querySelector('[data-store-q]');
        if (s) {
          e.preventDefault();
          s.focus();
        }
      }
    });
  });
})();

// PDP: set selector chooses quantity; price shows the honest multiple.
// 2026-08-08 strip-down: sets UI removed from product.liquid (one price, one ATC).
// Fallback binds ATCs at qty 1 from [data-pdp-solo]; multi-buy Function still
// discounts 2+/3+ silently at checkout. Restore sets block to re-enable tiers.
(function () {
  var wrap = document.querySelector('[data-pdp-sets]');
  var atcs = document.querySelectorAll('[data-pdp-atc]');
  if (!wrap) {
    var solo = document.querySelector('[data-pdp-solo]');
    if (!solo) return;
    var soloVariant = solo.dataset.variant;
    atcs.forEach(function (atc) {
      atc.addEventListener('click', function () {
        var title = document.querySelector('.euna-pdp-copy h1');
        window.EunaCart.add(soloVariant, 1, title ? title.textContent : '');
      });
    });
    return;
  }
  var base = parseFloat(wrap.dataset.base);
  var variantId = wrap.dataset.variant;
  var priceEls = document.querySelectorAll('[data-pdp-price]');
  var atcs = document.querySelectorAll('[data-pdp-atc]');
  function qty() {
    var checked = wrap.querySelector('input[type=radio]:checked');
    return parseInt((checked || {}).value || '1', 10);
  }
  // Must mirror the EUNA multi-buy Shopify Function: 2 = 10% off, 3+ = 20% off.
  function multiplier(q) { return q >= 3 ? 0.8 : (q === 2 ? 0.9 : 1); }
  function render() {
    wrap.querySelectorAll('.pdp-set').forEach(function (l) {
      l.classList.toggle('is-active', l.querySelector('input').checked);
    });
    var total = base * qty() * multiplier(qty());
    priceEls.forEach(function (el) {
      el.textContent = '$' + total.toFixed(2).replace(/\.00$/, '');
    });
  }
  wrap.addEventListener('change', render);
  atcs.forEach(function (atc) {
    atc.addEventListener('click', function () {
      var title = document.querySelector('.euna-pdp-copy h1');
      window.EunaCart.add(variantId, qty(), title ? title.textContent : '');
    });
  });
  render();
})();

// PDP tabs
(function () {
  var tabs = document.querySelector('[data-pdp-tabs]');
  if (!tabs) return;
  tabs.querySelector('.pdp-tabnav').addEventListener('click', function (e) {
    var b = e.target.closest('button[data-tab]');
    if (!b) return;
    tabs.querySelectorAll('.pdp-tabnav button').forEach(function (x) { x.classList.toggle('is-active', x === b); });
    tabs.querySelectorAll('.pdp-tabpanel').forEach(function (p) {
      p.classList.toggle('is-active', p.dataset.panel === b.dataset.tab);
    });
  });
})();
